import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import { PageContext } from 'pages/InstructorViewAssignmentFeedback/PageProvider';
import Desktop from 'pages/InstructorViewAssignmentFeedback/desktop';
import Mobile from 'pages/InstructorViewAssignmentFeedback/mobile';
import Tablet from 'pages/InstructorViewAssignmentFeedback/tablet';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, assignments, currentAssignmentId, currentAssignment, feedback } = useApp();
    const params = useParams();
    const { device } = useViewport();

    const props = useContext(PageContext);

    const { form, currentFeedbackItem } = props;

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (isLoading || currentAssignmentId !== params.id || !feedback || !form.feedback) return <Loading />;

    if ((assignments && !currentAssignment) || !currentFeedbackItem) return <ErrorPage />;

    return renderResponsiveLayout(device);
};

export default PageLayout;
